import { $api } from "@/lib/api-client";

export const useFetchWeekSelect = () => {
  return $api.useQuery("get", "/nft/weeks/select");
};
